export const QUERY_GET_PAYMENT_SUMMARY = `query GetBillPaymentList($input: BillPaymentInput!,$skip: Float, $take: Float){
    getBillPaymentList(where: $input, skip: $skip,take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            customerId
            tcustomer{
                id
                sapCustomerId
                mainCustomerId
                storeName
                name
                firstName
            }
            marketPrice
            finalPrice
            customerDebitId
            customerDebitQ10   
            customerDebitAmount
            pnjpDebitQ10
            pnjpDebitAmount
            paymentCustomerDebitAmount
            paymentCustomerDebitQ10
            paymentPnjpDebitAmount
            paymentPnjpDebitQ10
            tplant{
                id
                name
            }
            tstatus{
                id
                name
            }
            tcreateUser{
                id
                fullName
                plantCode
            }
            createDate
            tmodifyUser{
                id
                fullName
                plantCode
            }
            modifyDate
            tteamSale{
                id
                subId
                name
                teamType
            }
        }
    }
}`;

export const QUERY_GET_CUSTOMER_CHECKIN_BY_PLANT = `query getCustomerBillInPlant($input: CustomerBillInPlantInput!, $skip: Float, $take: Float){
    getCustomerBillInPlant(where: $input,skip: $skip, take: $take){
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items{
            id
            storeName
            sapCustomerId
            taxId
            cccd
            name
            plantId
            terrorismType
            terrorismUserApproval
            terrorismUserDate
        }
  }
}`;

export const QUERY_GET_ORDER_BILL_PAYMENT_LIST = `query getCustomerBillInPlant($id: String!){
    getOrderBillPaymentList(id: $id){
        code
        success
        message
        data{
            order{
                id
                plantId
                tcustomer{
                    id
                    storeName
                    sapCustomerId
                }
                tteamSale{
                    id
                    subId
                    name
                }
            }
            einvoiceUrl
        }
  }
}`;

export const QUERY_GET_ORDER_EXPORT_HDDT_LIST = `query GetOrderbySumPayment($input: orderBySumPaymentInput!){
    getOrderBySumPayment(where: $input){
      items{
        orderId
        soId
        doId
        giId
        billingId
        envoiceId
        errorMessage
        link
        status
        year
        orderTypeId
      }
    }
}`;
